import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditSDSRForm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const entry = location.state.entry;
    const { state } = useLocation();
   
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [formData, setFormData] = useState({
        token_id: entry.token_id,
        dsr_no: entry.dsr_no || '',
        dated: entry.dated || '',
        subject: entry.subject || '',
        location: entry.location || '',
        timings: entry.timings || '',
        approximate_strength: entry.approximate_strength || '',
        prominent_speakers: entry.prominent_speakers || '',
        hate_speech: entry.hate_speech || '',
        security_arrangements: entry.security_arrangements || '',
        special_activity: entry.special_activity || '',
        statement: entry.statement || '',
        copy_to: entry.copy_to || ''
    });

    useEffect(() => {
        const isValidDate = (date) => {
            const datePattern = /^\d{4}-\d{2}-\d{2}$/;
            return date && datePattern.test(date);
        };

        setFormData((prevData) => ({
            ...prevData,
            dated: isValidDate(entry.dated) ? entry.dated : new Date().toISOString().split('T')[0]
        }));
    }, [entry.dated]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'aruid') {
            return '/arms-dashboard';
        } else {
            console.error('Invalid user role:', state?.userRole);
            return '/dsr-dashboard';
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit-sdsr.php', {
                action: 'update',
                ...formData,
            });

            if (response.data?.status === 'success') {
                setShowPopup(true);
                setTimeout(() => {
                    setShowPopup(false);
                    navigate(getDashboardUrl());
                }, 2000);
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">DSR No.:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="dsr_no"
                                value={formData.dsr_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Dated:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="dated"
                                value={formData.dated}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Subject:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Location:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Timings:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="timings"
                                value={formData.timings}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Approximate Strength:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="approximate_strength"
                                value={formData.approximate_strength}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Prominent Speakers:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="prominent_speakers"
                                value={formData.prominent_speakers}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Hate Speech:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="hate_speech"
                                value={formData.hate_speech}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Security Arrangements:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="security_arrangements"
                                value={formData.security_arrangements}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Special Activity:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="special_activity"
                                value={formData.special_activity}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Statement:</label>
                        <div className="lc-input-container">
                            <input
                                name="statement"
                                value={formData.statement}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Copy To:</label>
                        <div className="lc-input-container">
                            <textarea
                                name="copy_to"
                                value={formData.copy_to}
                                onChange={handleChange}
                                className="lc-textarea"
                                required
                            />
                        </div>
                    </div>
                </div>
                
                <div className="lc-form-buttons">
                    <button type="submit" className="lc-submit-btn">
                        Update
                    </button>
                    <button type="button" className="lc-cancel-btn" onClick={handleCancel}>
                        Cancel
                    </button>
                </div>
            </form>
            
            {error && <div className="lc-error-message">{error}</div>}
            {showPopup && (
                <div className="lc-popup">
                    Entry updated successfully!
                </div>
            )}
        </div>
    );
};

export default EditSDSRForm;